import * as moment from "moment";

export function dateWithOptionalTime(date: any, withTime: boolean = false) {
  if (!date) return "";
  return withTime
    ? moment(date).locale(lang).format("YYYY-MM-DD LT")
    : moment(date).format("YYYY-MM-DD");
}
